module.exports = __webpack_public_path__ + "img/img16.7a797785.png";